module.exports = __webpack_public_path__ + "static/img/map.d39fcbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.png
// module id = /PMo
// module chunks = 1